/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { SettingsPageAutoChatReplyKeywordLinkSectionPanelAutoChatReplySettingFragmentDoc } from './SettingsPageAutoChatReplyKeywordLinkSectionPanel.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type AutoChatReplySettingExtraType =
  | 'BOOKING_REQUEST'
  | 'NONE'
  | 'QUESTION';

export type AutoChatReplySettingInputExtra = {
  bookingRequest?: AutoChatReplySettingInputExtraBookingRequest | null | undefined;
  /** 次のプロパティは extraType に対応した値が Non-null になっている */
  question?: AutoChatReplySettingInputExtraQuestion | null | undefined;
  type: AutoChatReplySettingExtraType;
};

export type AutoChatReplySettingInputExtraBookingRequest = {
  assignedCalendarGuid?: string | number | null | undefined;
  availableTimeSlotRange: ExtraBookingRequestAvailableTimeSlotRange;
  fallbackUrl?: string | null | undefined;
};

export type AutoChatReplySettingInputExtraQuestion = {
  selections: Array<string>;
};

export type ExtraBookingRequestAvailableTimeSlotRange =
  | 'ANYTIME'
  | 'WEEKDAY_ANYTIME'
  | 'WEEKDAY_DAYTIME'
  | 'WEEKDAY_NIGHT'
  | 'WEEKEND_ANYTIME'
  | 'WEEKEND_DAYTIME'
  | 'WEEKEND_NIGHT';

export type UpdateAutoChatReplySettingInput = {
  body: string;
  extra: AutoChatReplySettingInputExtra;
  id: string | number;
  isEnabled: boolean;
  keyword: string;
};

export type GetAutoChatReplySettingByIdQueryVariables = Exact<{
  id: string | number;
}>;


export type GetAutoChatReplySettingByIdQuery = { autoChatReplySetting: { id: string, body: string, keyword: string, isEnabled: boolean, extra: { type: Types.AutoChatReplySettingExtraType, question: { selections: Array<{ text: string, link: { id: string } | null }> } | null, bookingRequest: { fallbackUrl: string | null, assignedCalendarGuid: string | null, availableTimeSlotRange: Types.ExtraBookingRequestAvailableTimeSlotRange } | null } } };

export type UpdateAutoChatReplySettingMutationVariables = Exact<{
  input: Types.UpdateAutoChatReplySettingInput;
}>;


export type UpdateAutoChatReplySettingMutation = { updateAutoChatReplySetting:
    | { __typename: 'AutoChatReplySettingDuplicateKeywordError' }
    | { __typename: 'SaveAutoChatReplySettingSuccess', autoChatReplySetting: { id: string, body: string, keyword: string, isEnabled: boolean, extra: { type: Types.AutoChatReplySettingExtraType, question: { selections: Array<{ text: string, link: { id: string } | null }> } | null, bookingRequest: { fallbackUrl: string | null, assignedCalendarGuid: string | null, availableTimeSlotRange: Types.ExtraBookingRequestAvailableTimeSlotRange } | null } } }
   };

export type DeleteAutoChatReplySettingMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteAutoChatReplySettingMutation = { deleteAutoChatReplySetting: Array<{ id: string }> };


export const GetAutoChatReplySettingByIdDocument = gql`
    query getAutoChatReplySettingById($id: ID!) {
  autoChatReplySetting(id: $id) {
    id
    body
    keyword
    isEnabled
    extra {
      type
      question {
        selections {
          text
          link {
            id
          }
        }
      }
      bookingRequest {
        fallbackUrl
        assignedCalendarGuid
        availableTimeSlotRange
      }
    }
    ...SettingsPageAutoChatReplyKeywordLinkSectionPanelAutoChatReplySetting
  }
}
    ${SettingsPageAutoChatReplyKeywordLinkSectionPanelAutoChatReplySettingFragmentDoc}`;

/**
 * __useGetAutoChatReplySettingByIdQuery__
 *
 * To run a query within a Vue component, call `useGetAutoChatReplySettingByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoChatReplySettingByIdQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetAutoChatReplySettingByIdQuery({
 *   id: // value for 'id'
 * });
 */
export function useGetAutoChatReplySettingByIdQuery(variables: GetAutoChatReplySettingByIdQueryVariables | VueCompositionApi.Ref<GetAutoChatReplySettingByIdQueryVariables> | ReactiveFunction<GetAutoChatReplySettingByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAutoChatReplySettingByIdQuery, GetAutoChatReplySettingByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAutoChatReplySettingByIdQuery, GetAutoChatReplySettingByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAutoChatReplySettingByIdQuery, GetAutoChatReplySettingByIdQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetAutoChatReplySettingByIdQuery, GetAutoChatReplySettingByIdQueryVariables>(GetAutoChatReplySettingByIdDocument, variables, options);
}
export function useGetAutoChatReplySettingByIdLazyQuery(variables?: GetAutoChatReplySettingByIdQueryVariables | VueCompositionApi.Ref<GetAutoChatReplySettingByIdQueryVariables> | ReactiveFunction<GetAutoChatReplySettingByIdQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetAutoChatReplySettingByIdQuery, GetAutoChatReplySettingByIdQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetAutoChatReplySettingByIdQuery, GetAutoChatReplySettingByIdQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetAutoChatReplySettingByIdQuery, GetAutoChatReplySettingByIdQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetAutoChatReplySettingByIdQuery, GetAutoChatReplySettingByIdQueryVariables>(GetAutoChatReplySettingByIdDocument, variables, options);
}
export type GetAutoChatReplySettingByIdQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetAutoChatReplySettingByIdQuery, GetAutoChatReplySettingByIdQueryVariables>;
export const UpdateAutoChatReplySettingDocument = gql`
    mutation updateAutoChatReplySetting($input: UpdateAutoChatReplySettingInput!) {
  updateAutoChatReplySetting(input: $input) {
    __typename
    ... on SaveAutoChatReplySettingSuccess {
      autoChatReplySetting {
        id
        body
        keyword
        isEnabled
        extra {
          type
          question {
            selections {
              text
            }
          }
          bookingRequest {
            fallbackUrl
            assignedCalendarGuid
            availableTimeSlotRange
          }
        }
        ...SettingsPageAutoChatReplyKeywordLinkSectionPanelAutoChatReplySetting
      }
    }
    ... on AutoChatReplySettingDuplicateKeywordError {
      __typename
    }
  }
}
    ${SettingsPageAutoChatReplyKeywordLinkSectionPanelAutoChatReplySettingFragmentDoc}`;

/**
 * __useUpdateAutoChatReplySettingMutation__
 *
 * To run a mutation, you first call `useUpdateAutoChatReplySettingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutoChatReplySettingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAutoChatReplySettingMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAutoChatReplySettingMutation(options: VueApolloComposable.UseMutationOptions<UpdateAutoChatReplySettingMutation, UpdateAutoChatReplySettingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAutoChatReplySettingMutation, UpdateAutoChatReplySettingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAutoChatReplySettingMutation, UpdateAutoChatReplySettingMutationVariables>(UpdateAutoChatReplySettingDocument, options);
}
export type UpdateAutoChatReplySettingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAutoChatReplySettingMutation, UpdateAutoChatReplySettingMutationVariables>;
export const DeleteAutoChatReplySettingDocument = gql`
    mutation deleteAutoChatReplySetting($id: ID!) {
  deleteAutoChatReplySetting(id: $id) {
    id
  }
}
    `;

/**
 * __useDeleteAutoChatReplySettingMutation__
 *
 * To run a mutation, you first call `useDeleteAutoChatReplySettingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAutoChatReplySettingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAutoChatReplySettingMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAutoChatReplySettingMutation(options: VueApolloComposable.UseMutationOptions<DeleteAutoChatReplySettingMutation, DeleteAutoChatReplySettingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteAutoChatReplySettingMutation, DeleteAutoChatReplySettingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteAutoChatReplySettingMutation, DeleteAutoChatReplySettingMutationVariables>(DeleteAutoChatReplySettingDocument, options);
}
export type DeleteAutoChatReplySettingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteAutoChatReplySettingMutation, DeleteAutoChatReplySettingMutationVariables>;